interface AvatarProps {
  member: { name: string; avatar: string; color: string };
  size?: number;
  on?: boolean;
}

export function Avatar({ member, size = 32, on = false }: AvatarProps) {
  return (
    <div
      title={member.name}
      aria-label={member.name}
      role="img"
      className="rounded-full flex-shrink-0 flex items-center justify-center font-bold transition-all duration-200"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: on ? member.color : `${member.color}22`,
        color: on ? "#fff" : member.color,
        fontSize: size * 0.34,
        border: on ? `2px solid ${member.color}` : "2px solid transparent",
      }}
    >
      {member.avatar}
    </div>
  );
}
